import { render } from "./ReturnBillView.vue?vue&type=template&id=606a5150&scoped=true"
import script from "./ReturnBillView.vue?vue&type=script&lang=js"
export * from "./ReturnBillView.vue?vue&type=script&lang=js"

import "./ReturnBillView.vue?vue&type=style&index=0&id=606a5150&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606a5150"]])

export default __exports__